import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementIncidentNumbersComponent } from './case-management-incident-numbers.component';

const routes: Routes = [{ path: '', component: CaseManagementIncidentNumbersComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementIncidentNumbersRoutingModule { }
